import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { Event } from "./Event";
import { NoteCreate } from "./NoteCreate";
import { TaskCreate } from "./TaskCreate";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import CircularProgress from '@material-ui/core/CircularProgress';
import Time from "../../../Time/Time";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Card from '@material-ui/core/Card';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

class Timeline extends Component {
  protected refNoteCreateTextfield;
  protected refTaskCreateTextfield;
  protected sliceBy: number = 5;

  constructor(public props) {
    super(props);

    this.state = {
      selectedTabIndex: 0,
      isNoteCreateSectionOpen: false,
      isTaskCreateSectionOpen: false,
      currentActivityTemplate: null,
      isCreateActivityPopupOpen: false,
      sliceTimelineEvents: this.sliceBy,
      sliceInfoEvents: this.sliceBy,
      timelineEvents: [],
      infoEvents: [],
      anchorEl: null
    }
  }

  public componentWillMount() {
    this.filterEvents(this.props);
  }

  public componentWillReceiveProps(nextProps) {
    this.filterEvents(nextProps);
  }

  public filterEvents = (props) => {
    const timelineEvents = props.entityEvents.filter((event: EventInterface) => !event.removed && event.isTimelineEvent);
    const infoEvents = props.entityEvents.filter((event: EventInterface) => !event.removed && !event.isTimelineEvent);

    this.setState({
      timelineEvents: timelineEvents,
      infoEvents: infoEvents
    });
  }

  public openNoteCreateSection = (): void =>  {
    this.setState({
      isNoteCreateSectionOpen: true,
      isTaskCreateSectionOpen: false,
      anchorEl: null
    }, () => {
      setTimeout(() => {
        this.refNoteCreateTextfield.focusInput();
      }, 10);
    });
  }

  public closeNoteCreateSection = (): void => {
    this.setState({
      isNoteCreateSectionOpen: false
    });
  }

  public openTaskCreateSection = (): void =>  {
    this.setState({
      isTaskCreateSectionOpen: true,
      isNoteCreateSectionOpen: false,
      anchorEl: null
    }, () => {
      setTimeout(() => {
        this.refTaskCreateTextfield.focusInput();
      }, 10);
    });
  }

  public closeTaskCreateSection = (): void => {
    this.setState({
      isTaskCreateSectionOpen: false
    });
  }

  public createNote = (note: string, snoozeDate: Date | null): void => {
    const relations = {...this.props.relations};

    for (let relation in relations) {
      if (!relations[relation]) {
        delete relations[relation];
      }
    }

    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_CREATE_START,
      payload: {
        content: {
          note: note
        },
        snoozeDate: snoozeDate,
        eventTypeId: 17, // note
        ...relations
      },
      onSuccess: () => {
        this.closeNoteCreateSection();

        if (typeof this.props.fetchEntityEvents === "function") {
          this.props.fetchEntityEvents();
        }
      }
    });
  }

  public createTask = (task): void => {
    const relations = {...this.props.relations};

    for (let relation in relations) {
      if (!relations[relation]) {
        delete relations[relation];
      }
    }

    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_CREATE_START,
      payload: {
        content: {
          name: task.instructions
        },
        executionDate: task.executionDate ? Time.formatOrNull(task.executionDate) : null,
        snoozeDate: task.executionDate ? Time.formatOrNull(task.executionDate) : null,
        reacted: false,
        amazonFolderName: task.amazonFolderName,
        reporterId: task.reporterId,
        eventTypeId: 35, // task
        executorId: this.props.app?.session?.user?.id,
        ...relations
      },
      onSuccess: () => {
        this.closeTaskCreateSection();

        if (typeof this.props.fetchEntityEvents === "function") {
          this.props.fetchEntityEvents();
        }
      }
    });
  }

  public loadMore = (): void => {
    if (this.state.selectedTabIndex === 0) {
      this.setState({
        sliceTimelineEvents: this.state.sliceTimelineEvents + this.sliceBy
      });
    } else {
      this.setState({
        sliceInfoEvents: this.state.sliceInfoEvents + this.sliceBy
      });
    }
  }

  public switchTab = (event, tabValue): any => {
    event

    this.setState({
      selectedTabIndex: tabValue
    });
  }

  protected openMenu = (event: any): void => {
    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public render() {
    return (
      <div
        className="timeline"
      >
        <div>
          <Tabs
            className="tab tab-simple tab-contains-2 white-tabs same-size-tab"
            value={this.state.selectedTabIndex}
            onChange={this.switchTab}
          >
            <Tab label={this.trans("timeline")} value={0}/>
            <Tab label={this.trans("label-history")} value={1}/>
          </Tabs>

          {this.state.selectedTabIndex === 0 && (
            <Card
              className="card"
              style={{
                borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                maxHeight: "69.6hv"
              }}>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                  padding: "6px 6px 3px 6px"
                }}
              >
                <div>
                  <Button
                    color="primary"
                    onClick={this.openNoteCreateSection}
                    style={{padding: "0 2px", margin: "0 0 3px 0"}}
                  >
                    {this.trans("button-add-note")}
                  </Button>
                </div>
                {
                  (!!this.props.property || !!this.props.unit || !!this.props.charge || !!this.props.activity) && (
                    <div>
                      <Button
                        color="primary"
                        onClick={this.openTaskCreateSection}
                        style={{padding: "0 2px", margin: "0 0 3px 6px"}}
                      >
                        {this.trans("button-add-task")}
                      </Button>
                    </div>
                  )
                }
                {
                  !!this.props.unit && this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (
                    <div
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    >
                      <Button
                        color="primary"
                        onClick={this.openMenu}
                        style={{padding: "0 2px", margin: "0 0 3px 6px"}}
                      >
                        {this.trans("button-add-activity")}
                      </Button>
                      <Menu
                        id="simple-menu"
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.closeMenu}
                        disableAutoFocusItem={true}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center"
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left"
                        }}
                        getContentAnchorEl={null}
                      >
                        {
                          !!this.props.unit && this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (
                            this.props.app.activityTemplates
                              .filter(activityTemplate => !activityTemplate.removed)
                              .map((activityTemplate, key: number) => {
                                return (
                                  <MenuItem
                                    key={`activityTemplate-${key}`}
                                    onClick={() => {
                                      this.setState({
                                        isCreateActivityPopupOpen: true,
                                        currentActivityTemplate: activityTemplate,
                                        anchorEl: null
                                      })
                                    }}
                                  >
                                    <ListItemIcon><div className="icon icon-ic-activity aligned"></div></ListItemIcon>
                                    <ListItemText>{activityTemplate.name}</ListItemText>
                                  </MenuItem>
                                )
                              })
                          )
                        }
                      </Menu>
                    </div>
                  )
                }
              </div>

              <div className="event-container">
                {this.state.isNoteCreateSectionOpen && (
                  <NoteCreate
                    {...this.props}
                    ref={ref => this.refNoteCreateTextfield = ref}
                    createNote={this.createNote}
                    onCancel={this.closeNoteCreateSection}
                  />
                )}

                {this.state.isTaskCreateSectionOpen && (
                  <TaskCreate
                    {...this.props}
                    ref={ref => this.refTaskCreateTextfield = ref}
                    createTask={this.createTask}
                    onCancel={this.closeTaskCreateSection}
                  />
                )}

                {
                  this.props.fetchingEvents && (
                    <div style={{height: "100px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                      <CircularProgress />
                    </div>
                  )
                }

                {
                  this.state.timelineEvents
                    .sort((event1, event2) => {
                      if (new Date(event1.createdAt).valueOf() < new Date(event2.createdAt).valueOf()) {
                        return 1;
                      }
                      if (new Date(event1.createdAt).valueOf() > new Date(event2.createdAt).valueOf()) {
                        return -1;
                      }
                      return  0;
                    })
                    .slice(0, this.state.sliceTimelineEvents)
                    .map((event: EventInterface, index: number) => {
                      return (
                        <Event
                          {...this.props}
                          key={`event-${index}`}
                          event={event}
                        />
                      );
                    })
                }
              </div>

              {(this.state.timelineEvents && this.state.timelineEvents.length > this.state.sliceTimelineEvents) && (
                <div className="load-more-button">
                  <Button
                    color="primary"
                    onClick={this.loadMore}
                  >
                    {this.trans("button-load-more")}<div className="icon icon-ic-keyboard-arrow-down icon-color timeline-icon"></div>
                  </Button>
                </div>
              )}

              {(this.state.timelineEvents && this.state.timelineEvents.length === 0 && !this.props.fetchingEvents) && (
                <div style={{padding: "20px", backgroundColor: "white"}}>
                  {this.trans("tasks-notes-notifications-notfound")}
                </div>
              )}
            </Card>
          )}

          {this.state.selectedTabIndex === 1 && (
            <Card
              className="card"
              style={{
                borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                maxHeight: "69.6hv"
              }}>
              <div className="event-container">
                {
                  this.props.fetchingEvents && (
                    <div style={{height: "100px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                      <CircularProgress />
                    </div>
                  )
                }

                {
                  this.state.infoEvents
                    .sort((event1, event2) => {
                      if (new Date(event1.createdAt).valueOf() < new Date(event2.createdAt).valueOf()) {
                        return 1;
                      }
                      if (new Date(event1.createdAt).valueOf() > new Date(event2.createdAt).valueOf()) {
                        return -1;
                      }
                      return  0;
                    })
                    .slice(0, this.state.sliceInfoEvents)
                    .map((event: EventInterface, index: number) => {
                      return (
                        <Event
                          {...this.props}
                          key={`event-${index}`}
                          event={event}
                        />
                      );
                    })
                }
              </div>

              {(this.state.infoEvents && this.state.infoEvents.length > this.state.sliceInfoEvents) && (
                <div className="load-more-button">
                  <Button
                    color="primary"
                    onClick={this.loadMore}
                  >
                    {this.trans("button-load-more")}<div className="icon icon-ic-keyboard-arrow-down icon-color timeline-icon"></div>
                  </Button>
                </div>
              )}
            </Card>
          )}
        </div>

        <PromptDialog
          title={this.trans(
            "create-tasks-for",
            {
              activityTemplate: this.state.currentActivityTemplate ?
                this.state.currentActivityTemplate.name :
                ""
            }
          )
          }
          content={this.props.unit ?
            this.trans("you-are-about-to-create-task-for-activity-for-unit", {
              activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : "",
              unit: this.props.unit ? this.props.unit.displayName : ""}) :
            this.trans("you-are-about-to-create-task-for-activity-for-property", {
              activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : "",
              property: this.props.property && this.props.property.displayName ? this.props.property.displayName : ""})
          }
          openLeavePrompt={this.state.isCreateActivityPopupOpen}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("create-tasks")}
          prioritizeClosing={true}
          onDiscard={() => this.setState({ isCreateActivityPopupOpen: false })}
          onSave={() => {
            this.setState({ isCreateActivityPopupOpen: false },
              () => {
                if (this.props.unit) {
                  this.props.dispatch({
                    type: Constants.PAGE_ACTIVITY_CREATE_ADD_PARAMS,
                    payload: {
                      unitId: this.props.unit && this.props.unit.id
                    }
                  });

                  return this.redirect(`/app/activity/create/${this.state.currentActivityTemplate.id}/0/${this.props.unit.id}`);
                } else {
                  this.props.dispatch({
                    type: Constants.PAGE_ACTIVITY_CREATE_ADD_PARAMS,
                    payload: {
                      propertyId: this.props.property && this.props.property.id
                    }
                  });

                  return this.redirect(`/app/activity/create/${this.state.currentActivityTemplate.id}/${this.props.property.id}/0`);
                }
              });
          }}
          hideCross={true}
        />
      </div>
    );
  }
}

export { Timeline };
